import React from "react";
import Image from "components/image";
import RichText from "components/rich-text";
import { getRgba } from "helpers/get-rgba";
import clsx from "clsx/lite";

const PromoBlock = (props) => {
	const { content, image, alternate, bgColor } = props.data;
	return (
		<div className="w-full" style={{ backgroundColor: getRgba(bgColor) }}>
			<div
				className={clsx(
					"w-11/12 lg:w-3/4 gap-10 flex justify-between m-auto py-10",
					alternate ? "flex-col md:flex-row-reverse" : "flex-col-reverse md:flex-row"
				)}>
				<div className="ticks flex flex-col items-center lg:items-start justify-center">
					<RichText value={content} />
				</div>
				<div>
					<Image className="my-5" width={400} image={image.asset} alt={image?.alt} />
				</div>
			</div>
		</div>
	);
};

export default PromoBlock;
